import React, { useContext } from 'react';
import { RouteComponentProps, Switch } from 'react-router';
import { useLocation } from 'react-router-dom';

import { Journal } from '../journal/journal';
import { CompanyNews, MarketNews, News } from '../news/news';
import { PostCard } from '../post_card/post_card';
import { Articles } from '../articles/articles';
import { Blogs, MarketBlogs, SpecBlogs } from '../blogs/blogs';
import { MyBlog } from '../my_blog/my_blog';
import {
  CityQuestions,
  CommQuestions,
  CountryQuestions,
  ForeignQuestions,
  HypothecQuestions,
  MarketQuestions,
  Questions,
  SpecQuestions,
} from '../questions/questions';
import { PostPreview } from '../post_preview/post_preview';
import { AddBlog } from '../add_blog/add_blog';
import { RatingTable } from '../rating_table/rating_table';
import { AddQuestion } from '../add_question/add_question';
import { Unsubscribe } from '../unsubscribe/unsubscribe';
import { ApplicationContext } from '../../utils';
import { PageReload } from '../../components/PageReload';
import { Route } from '../../components/Route';

export interface IRoutesParams {
  onRender?(routeProps: RouteComponentProps): void;
}

export const Routes = (props: IRoutesParams) => {
  const {
    custom: { isNewDesignEnabled, newDesignSubdomains, subdomain },
  } = useContext(ApplicationContext);
  const { search } = useLocation();
  const qs = new URLSearchParams(search);
  const isCorrectSubdomain = newDesignSubdomains?.length ? newDesignSubdomains.includes(subdomain) : true;

  return (
    <Switch>
      <Route path={`/magazine/`} component={Journal}>
        {((isNewDesignEnabled && isCorrectSubdomain) || (!qs.get('tag') && !qs.get('search'))) && <PageReload />}
      </Route>
      <Route path={`/magazine-:path/`} component={Articles} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/novosti/market/`} component={MarketNews} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/novosti/company/`} component={CompanyNews} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/novosti/`} component={News} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/blogs-specialist/`} component={SpecBlogs} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/blogs-tendentsiy-rynka/`} component={MarketBlogs} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/blogs/`} component={Blogs} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/moi-blog/`} component={MyBlog} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov/`} component={Questions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-specialist/`} component={SpecQuestions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-tendentsiy-rynka/`} component={MarketQuestions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-gorodskaya-nedvizhimost/`} component={CityQuestions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-kommercheskaya-nedvizhimost/`} component={CommQuestions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-zagorodnaya-nedvizhimost/`} component={CountryQuestions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-zarubezhnaya-nedvizhimost/`} component={ForeignQuestions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-ipoteka/`} component={HypothecQuestions} {...props}>
        {isNewDesignEnabled && isCorrectSubdomain && <PageReload />}
      </Route>
      <Route path={`/forum-rieltorov-:id/`} component={PostCard} {...props} />
      <Route path={`/novosti-:id/`} component={PostCard} {...props} />
      <Route path={`/blogs-:id/`} component={PostCard} {...props} />
      <Route path={`/stati-:id/`} component={PostCard} {...props} />
      <Route path={`/preview`} component={PostPreview} {...props} />
      <Route path={`/add-blog/`} component={AddBlog} {...props} />
      <Route path={`/content-preview`} component={PostPreview} {...props} />
      <Route path={`/reyting-rieltorov/`} component={RatingTable} {...props} />
      <Route path={`/add-vopros/`} component={AddQuestion} {...props} />
      <Route path={`/unsubscribe-email/`} component={Unsubscribe} {...props} />
    </Switch>
  );
};
